import { render } from "./footer.vue?vue&type=template&id=53b909ce&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=53b909ce&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b909ce"]])

export default __exports__